import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { LiveViewUserModeEntryModel } from "../models/workView/liveViewUserModeEntry";
import { DayViewUserModeEntryWorkViewModel } from "../models/workView/dayViewUserModeEntryWorkView";
import { LiveViewProjectModeEntryModel } from "../models/workView/liveViewProjectModeEntry";
import { DayViewProjectModeEntriesModel } from "../models/workView/dayViewProjectModeEntries";
import { GuidItemModel } from "../models/shared/guidItem";
import { WeekViewUserModeUsersModel } from "../models/workView/weekViewUserModeUsersDTO";
import { WeekViewUserModeProjectDetailsModel } from "../models/workView/weekViewUserModeProjectDetailsDTO";
import { WeekViewUserModeProjectEntryModel } from "../models/workView/weekViewUserModeProjectEntryDTO";
import { WeekViewProjectModeUsersDetailsModel } from "../models/workView/weekViewProjectModeUsersDetailsDTO";
let WorkViewsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g;
    let WorkViewsModule = class WorkViewsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "workView";
            this.liveViewUserModeEntries = [];
            this.dayViewUserModeEntries = [];
            this.liveViewProjectModeEntries = [];
            this.dayViewProjectModeEntries = [];
            this.teams = [];
            this.weekViewUserModeUsers = [];
            this.weekViewUsersModeProjects = [];
            this.weekViewProjectModeProjects = [];
            this.weekViewProjectModeUsers = [];
        }
        async GetTeamList() {
            var url = `${getTenantId()}/${this.apiNode}/teams`;
            let { data } = await service.get(url);
            if (data) {
                this.SetTeams(plainToClass(GuidItemModel, data.teams));
                return data;
            }
        }
        async SetTeams(team) {
            this.teams = team;
        }
        async GetLiveViewUserModeEntries(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/live-User/${teamId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetLiveViewUserModeEntries(plainToClass(LiveViewUserModeEntryModel, data.clockWorkEntries));
                return data.clockWorkEntries;
            }
        }
        async GetDayWorkViewEntries(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/${payLoad.entryDate}/${payLoad.teamId}/day-User`;
            let { data } = await service.get(url);
            if (data) {
                this.SetDayWorkViewEntries(plainToClass(DayViewUserModeEntryWorkViewModel, data.employeeDayEntries));
                return data.employeeDayEntries;
            }
        }
        //project Live Users
        async GetLiveViewProjectModeUsers(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/live-Project/${teamId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetLiveViewProjectModeEntries(plainToClass(LiveViewProjectModeEntryModel, data.liveClockWorkEntriesForProjects));
                return data.liveClockWorkEntriesForProjects;
            }
        }
        // project mode day Users
        async GetDayViewProjectModeUsers(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/${payLoad.entryDate}/${payLoad.teamId}/day-Project`;
            let { data } = await service.get(url);
            if (data) {
                this.SetDayViewProjectModeEntries(plainToClass(DayViewProjectModeEntriesModel, data.dayClockWorkEntriesForProjects));
                return data.dayClockWorkEntriesForProjects;
            }
        }
        async GetWeekViewUserModeEntries(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/week-view/user-mode?entryDate=${payLoad.entryDate}&teamId=${payLoad.teamId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetWeekViewUserModeUsers(plainToClass(WeekViewUserModeUsersModel, data.users));
                this.SetWeekViewUserModeProjects(plainToClass(WeekViewUserModeProjectDetailsModel, data.projects));
                return data;
            }
        }
        async GetWeekViewProjectModeEntries(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/week-view/project-mode?entryDate=${payLoad.entryDate}&teamId=${payLoad.teamId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetWeekViewProjectModeUsers(plainToClass(WeekViewProjectModeUsersDetailsModel, data.users));
                this.SetWeekViewProjectModeProjects(plainToClass(WeekViewUserModeProjectEntryModel, data.projects));
                return data;
            }
        }
        async SetWeekViewUserModeUsers(users) {
            this.weekViewUserModeUsers = users;
        }
        async SetWeekViewUserModeProjects(projects) {
            this.weekViewUsersModeProjects = projects;
        }
        async SetWeekViewProjectModeUsers(users) {
            this.weekViewProjectModeUsers = users;
        }
        async SetWeekViewProjectModeProjects(projects) {
            this.weekViewProjectModeProjects = projects;
        }
        async SetLiveViewProjectModeEntries(liveViewProjectModeEntries) {
            this.liveViewProjectModeEntries = liveViewProjectModeEntries;
        }
        async SetDayViewProjectModeEntries(dayViewProjectModeEntries) {
            this.dayViewProjectModeEntries = dayViewProjectModeEntries;
        }
        async SetLiveViewUserModeEntries(liveViewUserModeEntries) {
            this.liveViewUserModeEntries = liveViewUserModeEntries;
        }
        async SetDayWorkViewEntries(dayViewUserModeEntries) {
            this.dayViewUserModeEntries = dayViewUserModeEntries;
        }
        clearLiveViewUserModeEntries() {
            this.liveViewUserModeEntries = [];
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], WorkViewsModule.prototype, "GetTeamList", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], WorkViewsModule.prototype, "SetTeams", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], WorkViewsModule.prototype, "GetLiveViewUserModeEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], WorkViewsModule.prototype, "GetDayWorkViewEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], WorkViewsModule.prototype, "GetLiveViewProjectModeUsers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], WorkViewsModule.prototype, "GetDayViewProjectModeUsers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], WorkViewsModule.prototype, "GetWeekViewUserModeEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], WorkViewsModule.prototype, "GetWeekViewProjectModeEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], WorkViewsModule.prototype, "SetWeekViewUserModeUsers", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], WorkViewsModule.prototype, "SetWeekViewUserModeProjects", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], WorkViewsModule.prototype, "SetWeekViewProjectModeUsers", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], WorkViewsModule.prototype, "SetWeekViewProjectModeProjects", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], WorkViewsModule.prototype, "SetLiveViewProjectModeEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], WorkViewsModule.prototype, "SetDayViewProjectModeEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], WorkViewsModule.prototype, "SetLiveViewUserModeEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], WorkViewsModule.prototype, "SetDayWorkViewEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], WorkViewsModule.prototype, "clearLiveViewUserModeEntries", null);
    WorkViewsModule = __decorate([
        Module({ dynamic: true, store: store, name: "workViews", namespaced: true })
    ], WorkViewsModule);
    return WorkViewsModule;
})();
export const WorkViewModule = getModule(WorkViewsModule);
